/**
 * PORTED — RO-3-03 / #44296.
 * Origin: `excellent/app/work/_period-filter.tsx`.
 *
 * Changes: next/navigation → @excellent/ui/router.
 */

import { usePathname, useNavigate, useSearch } from "@excellent/ui/router";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@excellent/ui";
import { PERIOD_LABEL, WORK_PERIODS, type WorkPeriod } from "./period";

/**
 * The Work-home period filter — scopes the dashboard's "Due" window via
 * `?period=`. A title-row DROPDOWN defaulting to Today.
 */
export function WorkPeriodFilter({ value }: { value: WorkPeriod }) {
  const navigate = useNavigate();
  const pathname = usePathname();
  const search = useSearch(); // URLSearchParams from the router seam

  const set = (p: WorkPeriod) => {
    const next = new URLSearchParams(search?.toString() ?? "");
    if (p === "today") next.delete("period");
    else next.set("period", p);
    const qs = next.toString();
    navigate.replace(qs ? `${pathname}?${qs}` : pathname);
  };

  return (
    <Select value={value} onValueChange={(v) => set(v as WorkPeriod)}>
      <SelectTrigger className="w-[9rem]" aria-label="Period">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {WORK_PERIODS.map((p) => (
          <SelectItem key={p} value={p}>
            {PERIOD_LABEL[p]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
